/*
function removeIframe(iframeId)
{
    jQuery(iframeId).remove();
    jQuery('.removeInput').remove();
}

function post_iframe(form,callback) 
{
    var input = document.createElement("input");
    jQuery(input).addClass('removeInput');
    jQuery(input).attr('type','hidden');
    jQuery(input).attr('name','action');
    jQuery(input).attr('value','verify_advanced');
    form.appendChild(input);
    
    var input = document.createElement("input");
    jQuery(input).addClass('removeInput');
    jQuery(input).attr('type','hidden');
    jQuery(input).attr('name','export_request');
    jQuery(input).attr('value','true');
    form.appendChild(input);
    
    var iframe = document.createElement("iframe");
    jQuery(iframe).attr("id", "upload_iframe");
    jQuery(iframe).attr("name", "upload_iframe");
    jQuery(iframe).attr("width", "0");
    jQuery(iframe).attr("height", "0");
    jQuery(iframe).attr("border", "0");
    jQuery(iframe).attr("style", "width: 0; height: 0; border: none;");
    jQuery(iframe).attr("src", "");
 
    form.parentNode.appendChild(iframe);
    window.frames['upload_iframe'].name = "upload_iframe";
 
    iframeId = document.getElementById("upload_iframe");
 
    var eventHandler2 = function () 
    {
        //alert(jQuery(iframeId).attr('src'));
        if (iframeId.detachEvent) iframeId.detachEvent("onload", eventHandler2);
        else iframeId.removeEventListener("load", eventHandler2, false);


        content = jQuery(iframeId).html();

        callback(content);
        setTimeout('removeIframe(iframeId)', 250);
    }
    
 
    if (iframeId.addEventListener) iframeId.addEventListener("load", eventHandler2, true);
    if (iframeId.attachEvent) iframeId.attachEvent("onload", eventHandler2);
 
    jQuery(form).attr("target", "upload_iframe");
    jQuery(form).attr("action", window.location.href);
    jQuery(form).attr("method", "post");
    jQuery(form).attr("enctype", "multipart/form-data");
    jQuery(form).attr("encoding", "multipart/form-data");
 
    jQuery(form)[0].submit();
}

function submit_iframe(form, callback)
{
    var frameName = "upload_iframe2";
    
    jQuery('.removeInput').remove();
    var input = document.createElement("input");
    jQuery(input).attr('type','hidden');
    jQuery(input).attr('name','export_request');
    jQuery(input).attr('value','true');
    form.appendChild(input);
    
    var iframe = document.createElement("iframe");
    jQuery(iframe).attr("id", frameName);
    jQuery(iframe).attr("name", frameName);
    jQuery(iframe).attr("width", "0");
    jQuery(iframe).attr("height", "0");
    jQuery(iframe).attr("border", "0");
    jQuery(iframe).attr("style", "width: 0; height: 0; border: none;");
    jQuery(iframe).attr("src", "");
 
    form.parentNode.appendChild(iframe);
    window.frames[frameName].name = frameName;
 
    iframeId = document.getElementById(frameName);
 
    var eventHandler = function () 
    {
       // alert(jQuery(iframeId).attr('src'));
        if (iframeId.detachEvent) iframeId.detachEvent("onload", eventHandler);
        else iframeId.removeEventListener("load", eventHandler, false);

        content = jQuery(iframeId).html();

        callback(content);

        setTimeout('removeIframe(iframeId)', 250);
    }
 
    if (iframeId.addEventListener) iframeId.addEventListener("load", eventHandler, true);
    if (iframeId.attachEvent) iframeId.attachEvent("onload", eventHandler);
 
    jQuery(form).attr("target", frameName);
    jQuery(form).attr("action", window.location.href);
    jQuery(form).attr("method", "post");
    jQuery(form).attr("enctype", "multipart/form-data");
    jQuery(form).attr("encoding", "multipart/form-data");
 
    jQuery(form)[0].submit();
}

function validate_iframe()
{
    var data = post_iframe(); 
}

// onAjax
function validate_ajax(form)
{
    post_ajax(form, function(data){
        jQuery(form).parent().replaceWith(data); 
        jQuery.fancybox.hideLoading();
    });
}

// onSuccess
function submit_ajax(form)
{
    jQuery.post(jQuery(self).attr('action'),jQuery(self).serialize(), function(data){
        jQuery(form).parent().replaceWith(data); 
        jQuery.fancybox.hideLoading();
    });   
}

// onClick
function doSubmit(form)
{
    // iframe
    submit_iframe(form,function(data){
        jQuery(form).parent().replaceWith(data); 
        jQuery.fancybox.hideLoading();
    });
    
    // ajax
    //submit_ajax(form);
}

function doVerify(form, data)
{
  //  var form = form;
    var obj = jQuery.parseJSON(data);
    if(!jQuery.isEmptyObject(obj))
    {
        jQuery(form).find('.lastColumn, .lastColumnError').each(function(){jQuery(this).html('');});
        for (var key in obj)
        {
            for(var errorKey in obj[key])
            {
                var newObj = jQuery(form).find('#'+key).parent().next();
                newObj.html(obj[key][errorKey]);
                newObj.removeClass('lastColumn');
                newObj.addClass('lastColumnError');
            }
        }   
    }
    else
    {
        doSubmit(form);
    }   
}

function post_ajax(form, callback)
{
    var params = jQuery(form).serializeArray();
    params.push({name: 'action', value: 'verify'});
    jQuery.post(jQuery(form).attr('action'), params, function(data){
        var obj = JSON && JSON.parse(data) || jQuery.parseJSON(data);
        if(!jQuery.isEmptyObject(obj))
        {
            jQuery(form).find('.lastColumn, .lastColumnError').each(function(){jQuery(this).html('');});
            for (var key in obj)
            {
                for(var errorKey in obj[key])
                {
                    var newObj = jQuery(form).find('#'+key).parent().next();
                    newObj.html(obj[key][errorKey]);
                    newObj.removeClass('lastColumn');
                    newObj.addClass('lastColumnError');
                }
            }   
        }
        else
        {
            submit_ajax(form, callback);    
        }
    });
}
         */
         
jQuery(function(){
 /*   jQuery(document.body).on('submit','.frm_central',function(e){
        var self = this;
        jQuery.fancybox.showLoading();
        var params = jQuery(self).serializeArray();
        var returnValue = true;
       
    
    });     */
    

    
    jQuery('.formulier-box').fancybox({
        'type': 'ajax',
        'autoDimensions': false,
        'width': 800,
        'height' : 400
    });
});

